module.exports = __webpack_public_path__ + "img/3.6f50d5a4.jpg";